import { graphql } from "@acto/gql";
import { useMemo } from "react";
import { useQuery } from "urql";
import { DataAccessResult } from "@acto/taskpane/core/data-access/types";
import { isFetchingResult } from "@acto/taskpane/core/data-access/isFetchingResult";
import { MeetingPrepCardReveal } from "@acto/taskpane/core/domain";

const RevealedMeetingPrepCardsQuery = graphql(`
  query GetRevealedMeetingPrepCards($clientId: ID!, $prepSessionId: String!) {
    revealedMeetingPrepCards(clientId: $clientId, prepSessionId: $prepSessionId) {
      id
      __typename
      clientId
      prepSessionId
      cardKey
    }
  }
`);

export function useRevealedMeetingPrepCards(
  clientId?: string,
  prepSessionId?: string | null,
): DataAccessResult<MeetingPrepCardReveal> {
  const [result] = useQuery({
    query: RevealedMeetingPrepCardsQuery,
    variables: { clientId: clientId ?? "", prepSessionId: prepSessionId ?? "" },
    pause: !clientId || !prepSessionId,
  });

  const requested = result.operation?.variables;
  const matchesRequest = requested?.clientId === clientId && requested?.prepSessionId === prepSessionId;
  const data = matchesRequest ? result.data : undefined;
  const error = matchesRequest ? result.error : undefined;
  const isFetching = isFetchingResult(result);
  const isPending = !data && isFetching;

  const reveals = useMemo(() => data?.revealedMeetingPrepCards.map(MeetingPrepCardReveal.fromGraphql), [data]);

  return {
    data: reveals,
    isFetching,
    isPending,
    error,
  };
}
